import React from 'react';
import {
    Box,
} from '@mui/material';

const ClinicalCriteria = (props) => {
    const policyContentRef = React.useRef(null);
    const [text, setText] = React.useState('');
    React.useEffect(() => {
        setText(props.policyData && props.policyData.clinical_criteria ? props.policyData.clinical_criteria : '')
    }, [props.policyData]);

    React.useEffect(() => {
        if (policyContentRef.current) {
            policyContentRef.current.innerHTML = text && text.trim().length > 0 ? text : 'No Data';

             // Force all links to open in a new tab
            const links = policyContentRef.current.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });
        }
    }, [text]);

    return (
        <Box>
            {text && text.trim().length > 0 && (
                <>
                    {/*<h2 className="sectionHeading">Clinical Criteria</h2>*/}
                    <div className="preview-header-section" style={{marginTop: '20px'}} >
                        <div ref={policyContentRef}></div>
                    </div>
                </>
            )}
        </Box>
    )
}

export default ClinicalCriteria;